<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Yeni Soru Ekle">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span><strong>Not:</strong> Eklenecek soru benzersiz olmalıdır...</span>
            </div>
          </b-alert>
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            to="/questions"
          >
            Soru Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Soru Ekleme Formu">
            <b-row>
              <b-col md="12">
                <b-form-group label="Soru" label-for="question">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Soru"
                  >
                    <b-form-textarea
                      id="question"
                      v-model="question"
                      placeholder="Soru"
                      rows="6"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="question.length >= chars.question ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="question.length >= chars.question ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ question.length }}</span>
                      /
                      {{ chars.question }}
                    </small>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Video">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Video"
                  >
                    <b-form-file
                      id="video"
                      v-model="video"
                      placeholder="Şeçtiğiniz videoyu buraya bırakın..."
                      drop-placeholder="Videoyu buraya bırakın..."
                      :state="errors.length > 0 ? false : null"
                  /></validation-provider>
                  <b-card-text class="my-1">
                    Seçilen Video : <strong>{{ video ? video.name : "" }}</strong>
                  </b-card-text>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Mobil Video">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Mobil Video"
                  >
                    <b-form-file
                      id="mobileVideo"
                      v-model="mobileVideo"
                      placeholder="Şeçtiğiniz videoyu buraya bırakın..."
                      drop-placeholder="Videoyu buraya bırakın..."
                      :state="errors.length > 0 ? false : null"
                  /></validation-provider>
                  <b-card-text class="my-1">
                    Seçilen Video : <strong>{{ mobileVideo ? mobileVideo.name : "" }}</strong>
                  </b-card-text>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-for="(answer, index) in answers" :key="index">
              <b-col md="12">
                <b-form-group :label="`Cevap ${index + 1}`" :label-for="`answer${index}`">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    :name="`Cevap ${index + 1}`"
                  >
                    <b-form-textarea
                      :id="`answer${index}`"
                      v-model="answer.text"
                      :placeholder="`Cevap ${index + 1}`"
                      rows="6"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="answer.text.length >= chars.answer ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="answer.text.length >= chars.answer ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ answer.text.length }}</span>
                      /
                      {{ chars.answer }}
                    </small>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  :label="`Çarpan ${index + 1}`"
                  :label-for="`multiplier${index}`"
                >
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Alkol Oranı"
                  >
                    <b-form-input
                      :id="`multiplier${index}`"
                      v-model="answer.multiplier"
                      placeholder="Alkol Oranı"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        answer.multiplier.length >= chars.multiplier ? 'text-danger' : ''
                      "
                      type="number"
                      inputmode="decimal"
                      step="0.5"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        answer.multiplier.length >= chars.multiplier ? 'bg-danger' : ''
                      "
                    >
                      <span class="char-count">{{ answer.multiplier.length }}</span>
                      /
                      {{ chars.multiplier }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group></b-col
              >
              <br />
              <br />
            </b-row>
            <b-row>
              <b-col md="12" class="mt-5">
                <div>
                  <b-button
                    class="float-right mt-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    @click="postConfirmText(false)"
                  >
                    <b-spinner v-if="spinner === true && isDraft === false" small />
                    {{
                      spinner === true && isDraft === false ? "Yayınlanıyor" : "Yayınla"
                    }}
                  </b-button>
                </div>
                <div>
                  <b-button
                    class="float-right mt-2 mr-1"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-warning"
                    @click="postConfirmText(true)"
                  >
                    <b-spinner v-if="spinner == true && isDraft == true" small />
                    {{
                      spinner == true && isDraft == true
                        ? "Taslağa Kaydediliyor"
                        : "Taslağa Kaydet"
                    }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card></b-col
        >
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import Editor from "../components/Editor";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    Editor,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      video: null,
      mobileVideo: null,
      question: "",
      answers: [],
      answer: {
        answer: "",
        multiplier: 0
      },
      answerCount: 5,
      isDraft: false,
      spinner: false,
      chars: {
        question: 1500,
        answer: 1500,
        multiplier: 1,
      },
    };
  },
  watch: {},
  methods: {
    postConfirmText(isDraft) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Yeni soruyu kaydetmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let formData = new FormData();
          formData.append("question", this.question);
          formData.append("answers", JSON.stringify(this.answers));
          formData.append("isDraft", this.isDraft ? 1 : 0);
          formData.append("video", this.video);
          formData.append("mobileVideo", this.mobileVideo);
          endpoints
            .postQuestion(formData, this.$i18n.locale, () => {})
            .then((data) => {
              this.spinner = false;
              if (data.status) {
                this.$swal({
                  icon: "success",
                  title: "Kayıt başarılı!",
                  text: "Yeni soru eklendi.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((result) => {
                  if (result.value) {
                    this.$router.push({
                      path: `/questions`,
                    });
                  }
                });
              } else {
                this.$swal({
                  title: "Hata!",
                  text: "Soru benzersiz değil!",
                  icon: "error",
                  confirmButtonText: "Tamam",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then((result) => {
                  if (result.value) {
                  }
                });
              }
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
  },
  created() {},
  destroyed() {},
  mounted() {
    for (let i = 0; i < this.answerCount; i++) {
      this.answers.push({
        text: "",
        multiplier: 0
      });
    }
  },
  setup() {},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
